import { lazy, Suspense, useMemo } from "react";
import ComingSoonPage from "@/components/ComingSoonPage";
import NotFoundPage from "@/components/NotFoundPage";
import UpgradePrompt from "@/components/UpgradePrompt";
import { ACCESS_TIERS } from "@/config/routeAccess";
import { useEntitlements } from "@/context/EntitlementsContext";

function AccessLoading() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center text-sm text-muted-foreground">
      Checking access...
    </div>
  );
}

export default function RouteGuard({ tier, children, loadPrivate }) {
  const entitlements = useEntitlements();
  const PrivateComponent = useMemo(
    () => (loadPrivate ? lazy(loadPrivate) : null),
    [loadPrivate]
  );

  if (tier === ACCESS_TIERS.FREE) return children;
  if (tier === ACCESS_TIERS.NOT_FOUND) return <NotFoundPage />;
  if (tier === ACCESS_TIERS.COMING_SOON) return <ComingSoonPage />;

  if (tier === ACCESS_TIERS.CORE) {
    if (entitlements.loading) return <AccessLoading />;
    return entitlements.isResearchPlus ? children : <UpgradePrompt />;
  }

  if (tier === ACCESS_TIERS.OWNER) {
    if (entitlements.loading) return <AccessLoading />;
    if (!entitlements.is_owner) return <NotFoundPage />;
    if (PrivateComponent) {
      return (
        <Suspense fallback={<AccessLoading />}>
          <PrivateComponent />
        </Suspense>
      );
    }
    return children || <NotFoundPage />;
  }

  return <NotFoundPage />;
}

